import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-operational',
    template: '<p>operational works!</p>',
    standalone: false
})
export class OperationalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
